import welfareService from '@/service/welfare';
import { toggleValue } from '@/store';
import localforage from 'localforage';
import { isEmpty } from 'lodash';
import { observable, action, runInAction } from 'mobx';
import moIndex from '../../store';


// 获取人均福利分布

const moWelfare = observable({
  PerCapitaWelfareDate: <any>[],
  PerWelfareDistributionDate: <any>[],
  WelfareCityRankDate: <any>[],
  ProjectAdoptionList: <any>[],
  ProjectAdoptionDate: <any>[],
  WelfareBudgetAmountDate: <any>[],
  KeyFestivalsDate: <any>[],
  KeyFestivalsList: <any>[],
  provinceName: <string>'上海',
  cityNames: <string>'上海',
  provinceList: <any>[],
  cityList: <any>[],
  allYearData: <any>{},
  allYearRankLeft: <any>[],
  allYearRankMid: <any>[],
  allYearRankRight: <any>[],
  allYearDefault: 'employee_count_rankings',
  AllYearTopList: <any>[],
  AllYearTopData: <any>[],
  AllYearTop: <any>{},
  keyHolidayNum: <string>'employee_count_rankings',
  keyHoliday: <string>'端午',
  keyHolidayDefaultNum: 1,
  keyHolidayData: <any>{},
  keyHolidayLeft: <any>[],
  keyHolidayMid: <any>[],
  keyHolidayRight: <any>[],
  KeyHolidayTopList: <any>[],
  KeyHolidayTopData: <any>[],
  KeyHolidayTop: <any>{},
  activeDays: '春节',
  dayList: [],
  activeDay: <any>0,
  activeCity: '',
});

// 获取人均福利

const getPerWelfare = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,

  };
  const PerResult = await welfareService.GetPerCapitaWelfare(parmes);
  runInAction(() => {
    const data = [PerResult?.fw_25, PerResult?.fw_50, PerResult?.fw_75];
    moWelfare.PerCapitaWelfareDate = data;
  });
});


const getWelfareDistribution = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetPerCapitaWelfareDistribution(parmes);
  runInAction(() => {
    const list = PerResult?.map((item: any) => {
      const res: any = {};
      res.label = item.section;
      res.rate = item.percent;
      return res;
    });
    moWelfare.PerWelfareDistributionDate = list;
  });
});

// 获取人均福利城市排行

const getWelfareRank = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetPerCapitaWelRank(parmes);
  runInAction(() => {
    const list = PerResult?.map((item: any) => {
      const res: any = {};
      res.city = item.city_name;
      res.amount = item.number;
      return res;
    });
    moWelfare.WelfareCityRankDate = list;
  });
});

// 福利项目采用情况
const getProjectAdoption = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetWelfareProjectAdoption(parmes);
  runInAction(() => {
    const list: any = [];
    const data: any = [];
    PerResult?.forEach((ele: any) => {
      list.push(ele.product);
      data.push(ele.percent);
    });
    moWelfare.ProjectAdoptionList = list;
    moWelfare.ProjectAdoptionDate = data;
  });
});

// 福利预算占比

const getBudgetAmount = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetWelfareBudgetAmount(parmes);
  runInAction(() => {
    const list = PerResult?.map((item: any) => {
      const res: any = {};
      res.label = item.product;
      res.rate = item.percent;
      return res;
    });
    moWelfare.WelfareBudgetAmountDate = list;
  });
});

// 重点节日福利
const getKeyFestivals = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetWelfareKeyFestivals(parmes);
  const klist: any = [];
  const kDate: any = [];
  PerResult?.forEach((item: any) => {
    klist.push(item.festival);
    kDate.push({ data: [{ rate: item.fw_25 }, { rate: item.fw_50 }, { rate: item.fw_75 }] });
  });
  runInAction(() => {
    moWelfare.KeyFestivalsDate = kDate;
    moWelfare.KeyFestivalsList = klist;
  });
});

// 员工喜好城市
const getLikesCity = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetEmployeePreferences(parmes);
  const local: any = await localforage.getItem('hobby') || {};
  const province = !isEmpty(PerResult) ? PerResult[0].province : '';
  const result = local.province || province;
  runInAction(() => {
    moWelfare.provinceName = result;
    const list = PerResult?.filter((item: any) => item.province === result);
    moWelfare.provinceList = PerResult;
    const res = !isEmpty(list) ? list[0].city_list : [];
    moWelfare.cityList = res;
    moWelfare.cityNames = local.cityNames || (!isEmpty(res) ? res[0] : '');
  });
});

// 修改省份
const changeWelfareProvince = action(async (val: string) => {
  const list = moWelfare.provinceList?.filter((item: any) => item.province === val);
  runInAction(() => {
    moWelfare.provinceName = val;
    moWelfare.cityList = list[0].city_list;
  });
  const res: any = await localforage.getItem('hobby') || {};
  res['province'] = val;
  localforage.setItem("hobby", res)
});

// 修改城市
const changeWelfareCity = action(async (val: string) => {
  runInAction(() => {
    if (moWelfare.cityNames !== val) {
      moWelfare.cityNames = val;
      moWelfare.allYearDefault = 'employee_count_rankings';
      moWelfare.keyHolidayNum = 'employee_count_rankings';
      moWelfare.keyHolidayDefaultNum = 0;
      moWelfare.keyHoliday = '春节';
      getRedemption();
      getKeyholidayRanking();
    }
  });
  const res: any = await localforage.getItem('hobby') || {};;
  res['cityNames'] = val;
  localforage.setItem("hobby", res)
});

// 全年兑换福利排行
const getRedemption = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
    city: moWelfare.cityNames,
  };
  const PerResult = await welfareService.GetRedemptionRanking(parmes);
  runInAction(() => {
    const res = PerResult?.employee_count_rankings?.channels;
    moWelfare.allYearData = PerResult;
    moWelfare.allYearRankLeft = res || [];
    moWelfare.allYearRankMid = res?.length > 0 ? res[0]?.categories : [];
    moWelfare.allYearRankRight = PerResult?.employee_count_rankings?.brands || [];
  });
});

// 改变全年兑换福利人数和数量
const changeAllYearTab = action(async (val: string) => {
  const list: any = [];
  const data: any = [];
  moWelfare.AllYearTop[val]?.forEach((item: any) => {
    list.push(item.city_name);
    data.push(item.percent);
  });
  runInAction(() => {
    moWelfare.allYearDefault = val;
    const res = moWelfare.allYearData[val]?.channels;
    moWelfare.allYearRankLeft = moWelfare.allYearData[val]?.channels || [];
    moWelfare.allYearRankMid = res.length > 0 ? res[0]?.categories : [];
    moWelfare.allYearRankRight = moWelfare.allYearData[val]?.brands || [];
    moWelfare.AllYearTopList = list;
    moWelfare.AllYearTopData = data;
  });
  const res: any = await localforage.getItem('hobby') || {};;
  res['allYear'] = val;
  localforage.setItem("hobby", res)
});


// 改变兑换全年福利中间内容
const changeAllYearMid = action((val: string) => {
  const list = moWelfare.allYearRankLeft.filter((item: any) => {
    return item.name === val;
  });
  runInAction(() => {
    moWelfare.allYearRankMid = list[0].categories;
  });
});

// 全年福利兑换top10
const getAllYearTop = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  moWelfare.AllYearTopList = [];
  moWelfare.AllYearTopData = [];
  moWelfare.AllYearTop = [];
  const PerResult = await welfareService.GetAllYearTop(parmes);
  runInAction(() => {
    const list: any = [];
    const data: any = [];
    PerResult?.employee_count_rankings?.forEach((item: any) => {
      list.push(item.city_name);
      data.push(item.percent);
    });
    moWelfare.AllYearTopList = list;
    moWelfare.AllYearTopData = data;
    moWelfare.AllYearTop = PerResult;
  });
});

// 重点城市兑换排行
const getKeyholidayRanking = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
    city: moWelfare.cityNames,
  };
  moWelfare.keyHolidayLeft = [];
  moWelfare.keyHolidayMid = [];
  moWelfare.keyHolidayRight = [];
  const PerResult = await welfareService.GetKeyholidayRanking(parmes);
  runInAction(() => {
    moWelfare.keyHolidayData = PerResult;
    const list = PerResult?.filter((ele: any) => ele.employee_count_rankings && ele.exchange_count_rankings);
    moWelfare.dayList = list;
    if (list?.length > 0) {
      let index = '';
      if (list[0].employee_count_rankings) {
        index = 'employee_count_rankings';
      } else if (list[0].exchange_count_rankings) {
        index = 'exchange_count_rankings';
      } else {
        index = 'employee_count_rankings';
      }
      const res = list[0][index]?.channels;
      moWelfare.activeDays = list[0].festival;
      moWelfare.keyHolidayNum = index;
      moWelfare.keyHolidayLeft = res || [];
      moWelfare.keyHolidayMid = res.length > 0 ? res[0]?.categories : [];
      moWelfare.keyHolidayRight = list[0][index]?.brands || [];
    } else {
      moWelfare.activeDays = '春节';
      moWelfare.keyHolidayLeft = [];
      moWelfare.keyHolidayMid = [];
      moWelfare.keyHolidayRight = [];
    }
  });
});

// 修改重点兑换城市数量人数
const changeKeyHolidayTab = action(async (val: string) => {
  const result = moWelfare.keyHolidayData.filter((item: any) => item.festival === moWelfare.keyHoliday);
  const topResult = moWelfare.KeyHolidayTop.filter((item: any) => item.festival === moWelfare.keyHoliday);
  const list: any = [];
  const data: any = [];
  runInAction(() => {
    moWelfare.KeyHolidayTopList = [];
    moWelfare.KeyHolidayTopData = [];
    moWelfare.keyHolidayNum = val;
    if (result.length > 0) {
      const res = result[0][val]?.channels;
      moWelfare.keyHolidayLeft = res || [];
      moWelfare.keyHolidayMid = res.length > 0 ? res[0]?.categories : [];
      moWelfare.keyHolidayRight = result[0][val]?.brands || [];
    } else {
      moWelfare.keyHolidayLeft = [];
      moWelfare.keyHolidayMid = [];
      moWelfare.keyHolidayRight = [];
    }
    if (topResult.length > 0) {
      topResult[0][val]?.forEach((item: any) => {
        list.push(item.city_name);
        data.push(item.percent);
      });
      moWelfare.KeyHolidayTopList = list;
      moWelfare.KeyHolidayTopData = data;
    } else {
      moWelfare.KeyHolidayTopList = [];
      moWelfare.KeyHolidayTopData = [];
    }
  });
  const res: any = await localforage.getItem('hobby') || {};;
  res['keyHolidayNum'] = val;
  localforage.setItem("hobby", res)
});

// 鼠标移上去变化

const changeMouse = action((val: string) => {
  runInAction(() => {
    moWelfare.activeCity = val;
  })
})

// 改变兑换重点城市福利中间内容
const changeKeyHolidayMid = action((val: string) => {
  const list = moWelfare.keyHolidayLeft.filter((item: any) => {
    return item.name === val;
  });
  runInAction(() => {
    moWelfare.keyHolidayMid = list[0].categories;
  });
});

// 获取重点城市福利兑换top10
const getKeyHolidayTop = action(async () => {
  const parmes = {
    industry: moIndex.industry.code,
  };
  const PerResult = await welfareService.GetKeyHolidayTop(parmes);
  runInAction(() => {
    const result = PerResult?.filter((item: any) => item.festival === moWelfare.keyHoliday);
    const list: any = [];
    const data: any = [];
    moWelfare.KeyHolidayTopList = [];
    moWelfare.KeyHolidayTopData = [];
    moWelfare.KeyHolidayTop = [];
    moWelfare.KeyHolidayTop = PerResult;
    if (result?.length > 0) {
      result[0].employee_count_rankings?.forEach((item: any) => {
        list.push(item.city_name);
        data.push(item.percent);
      });
      moWelfare.KeyHolidayTopList = list;
      moWelfare.KeyHolidayTopData = data;
    } else {
      moWelfare.KeyHolidayTopList = [];
      moWelfare.KeyHolidayTopData = [];
    }
  });
});

// 修改重点兑换城市节日

const changeKeyHoliday = action(async (val: number) => {
  const datas = ['春节', '端午', '中秋'];
  const result = moWelfare.keyHolidayData.filter((item: any) => item.festival === datas[val]);
  const topResult = moWelfare.KeyHolidayTop.filter((item: any) => item.festival === datas[val]);
  const list: any = [];
  const data: any = [];
  runInAction(() => {
    moWelfare.KeyHolidayTopList = [];
    moWelfare.KeyHolidayTopData = [];
    moWelfare.keyHoliday = datas[val];
    moWelfare.keyHolidayDefaultNum = val;
    moWelfare.activeDay = val;
    if (result.length > 0) {
      const res = result[0][moWelfare.keyHolidayNum]?.channels;
      moWelfare.keyHolidayLeft = res || [];
      moWelfare.keyHolidayMid = res.length > 0 ? res[0]?.categories : [];
      moWelfare.keyHolidayRight = result[0][moWelfare.keyHolidayNum]?.brands || [];
    } else {
      moWelfare.keyHolidayLeft = [];
      moWelfare.keyHolidayMid = [];
      moWelfare.keyHolidayRight = [];
    }
    if (topResult.length > 0) {
      topResult[0][moWelfare.keyHolidayNum]?.forEach((item: any) => {
        list.push(item.city_name);
        data.push(item.percent);
      });
      moWelfare.KeyHolidayTopList = list;
      moWelfare.KeyHolidayTopData = data;
    } else {
      moWelfare.KeyHolidayTopList = [];
      moWelfare.KeyHolidayTopData = [];
    }
  });
  const res: any = await localforage.getItem('hobby') || {};;
  res['activeDay'] = val;
  localforage.setItem("hobby", res)
});

const welfareInit = action(async () => {
  await getLikesCity();
  const local: any = await localforage.getItem('hobby') || {};
  runInAction(() => {
    moWelfare.allYearDefault = local.allYear || 'employee_count_rankings';
    moWelfare.keyHolidayNum = local.keyHolidayNum || 'employee_count_rankings';
    moWelfare.activeDay = local.activeDay || 0;
  })
  await Promise.all([
    getPerWelfare(),
    getWelfareDistribution(),
    getWelfareRank(),
    getProjectAdoption(),
    getBudgetAmount(),
    getKeyFestivals(),
    getRedemption(),
    getAllYearTop(),
    getKeyholidayRanking(),
    getKeyHolidayTop()
  ]);
});

export default moWelfare;
export {
  welfareInit, changeWelfareProvince, changeWelfareCity, changeAllYearTab, changeAllYearMid,
  changeKeyHolidayTab, changeKeyHolidayMid, changeKeyHoliday, changeMouse
};
